
// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import SearchController from "./search_controller"
application.register("search", SearchController)

import ElementRemovalController from "./element_removal_controller"
application.register("element-removal", ElementRemovalController)

import AvatarInputController from "./avatar_input_controller"
application.register("avatar-input", AvatarInputController)

import DirectUploadController from "./direct_upload_controller"
application.register("direct-upload", DirectUploadController)

import ScrollController from "./scroll_controller"
application.register("scroll", ScrollController)

import ConversationController from "./conversation_controller"
application.register("conversation", ConversationController)

import InputDisplayController from "./input_display_controller"
application.register("input-display", InputDisplayController)

import SidebarConversationFormController from "./sidebar_conversation_form_controller"
application.register("sidebar-conversation-form", SidebarConversationFormController)

import FoldersFormController from "./folders_form_controller"
application.register("folders-form", FoldersFormController)

import UploadPreviewController from "./upload_preview_controller"
application.register("upload-preview", UploadPreviewController)

import FormController from "./form_controller"
application.register("form", FormController)

import CheckboxCountersController from "./checkbox_counters_controller"
application.register("checkbox-counters", CheckboxCountersController)

import DriverAdminVisibilityController from "./driver_admin_visibility_controller"
application.register("driver-admin-visibility", DriverAdminVisibilityController)

import TemporaryController from "./temporary_controller"
application.register("temporary", TemporaryController)

import RemoveHighlightController from "./remove_highlight_controller"
application.register("remove-highlight", RemoveHighlightController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import VoiceRecorderController from "./voice_recorder_controller"
application.register("voice-recorder", VoiceRecorderController)

import VoicePlayerController from "./voice_player_controller"
application.register("voice-player", VoicePlayerController)

import PhotosController from "./photos_controller"
application.register("photos", PhotosController)

import VideosController from "./videos_controller"
application.register("videos", VideosController)

import SubscriptionController from "./subscription_controller"
application.register("subscription", SubscriptionController)

import DeleteModalController from "./delete_modal_controller"
application.register("delete-modal", DeleteModalController)

import SignUpFormController from "./sign_up_form_controller"
application.register("sign-up-form", SignUpFormController)

import ReauthenticationController from "./reauthentication_controller"
application.register("reauthentication", ReauthenticationController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ScrollToController from "./scroll_to_controller"
application.register("scroll-to", ScrollToController)

import CheckoutController from "./checkout_controller"
application.register("checkout", CheckoutController)

import AccountDeletionController from "./account_deletion_controller"
application.register("account-deletion", AccountDeletionController)

import CardPaymentController from "./card_payment_controller"
application.register("card-payment", CardPaymentController)

import PrintController from "./print_controller"
application.register("print", PrintController)

import TermsGateController from "./terms_gate_controller"
application.register("terms-gate", TermsGateController)
